import { TRANSITION_FAST, TRANSITION_SLOW } from '../constants/constants';

// let SITE_BLOCKER;

const CLASS_TRANSITION = 'transition';
const FAST = 'fast';
const BTN_CLOSE = ' .btn.btn--close';

// Site blocker (transparent blue background)
export const BLOCKER_ID = '#site-blocker';

// All possible popups

// Popup Default
export const POPUP_DEFAULT_ID = '#site-popup__default';
// Popup Contact
export const POPUP_CONTACT_ID = '#site-popup__contact';
// Popup Image
export const POPUP_IMAGE_ID = '#site-popup__image';
// Popup Share
export const POPUP_SHARE_ID = '#site-popup__share';
// Popup Alert Decent
export const POPUP_ALERT_DECENT_ID = '#siteAlertDecent';
// Popup Alert Prominent
export const POPUP_ALERT_PROMINENT_ID = '#siteAlertProminent';

// Close all popups, but the one that opens (doNotCloseThisPopup)
function closeOtherPopups(doNotCloseThisPopup) {
  [
    POPUP_DEFAULT_ID,
    POPUP_CONTACT_ID,
    POPUP_IMAGE_ID,
    POPUP_SHARE_ID,
    //POPUP_ALERT_DECENT_ID,
    POPUP_ALERT_PROMINENT_ID,
  ].forEach((identifier) => {
    if (doNotCloseThisPopup !== identifier) {
      hideElementTransition($(identifier), FAST);
    }
  });
}

export function showElementTransition(el, transitionSpeed) {
  el.addClass('active');
  if (transitionSpeed == FAST) {
    el.addClass(FAST);
  }
  setTimeout(function() {
    el.addClass(CLASS_TRANSITION);
  }, 5);
}

export function hideElementTransition(el, transitionSpeed) {
  const transitionTime = getTransitionTime(transitionSpeed);
  el.removeClass('transition');
  setTimeout(function() {
    el.removeClass('active ' + FAST);
  }, transitionTime);
}

export function getTransitionTime(transitionSpeed = FAST) {
  return transitionSpeed == FAST ? TRANSITION_FAST : TRANSITION_SLOW;
}

export function showSiteBlocker(siteBlocker, transitionSpeed, butThisPopup) {
  closeOtherPopups(butThisPopup);
  showElementTransition(siteBlocker, transitionSpeed);
}

export function hideSiteBlocker(siteBlocker, transitionSpeed) {
  hideElementTransition(siteBlocker, transitionSpeed);
}

document.addEventListener('DOMContentLoaded', function() {
  const SITE_BLOCKER = $(BLOCKER_ID);

  // Close popups on ESCAPE Key
  $(document).on('keydown', function(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      closeOtherPopups();
      hideSiteBlocker(SITE_BLOCKER, FAST);
    }
  });

  // Close Popups on click of the site blocker element in the background
  SITE_BLOCKER.click(function(e) {
    closeOtherPopups();
    hideSiteBlocker(SITE_BLOCKER, FAST);
  });
});
